export const logoutEvents = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
